import { Col, Input, Row, Spin, Tabs, Timeline } from 'antd'
import Axios from 'axios'
import moment from 'moment'
import React from 'react'
import Batch from '../../component/batch/index'
import { useSelector } from 'react-redux'
import { AuthReducerState, IApplicationState } from '../../state'
const { TextArea } = Input
const { TabPane } = Tabs

interface IProps {}

const BatchRegister: React.FC<IProps> = (props) => {
    const auth = useSelector<IApplicationState, AuthReducerState>((state) => state.auth)
    const [state, setState] = React.useState({
        data: [] as any[],
        activeKey: '',
        index: 1,
        note: '',
        his: [] as any[],
        realTimeHistory: [] as any[],
        ref: {} as any,
        loading: false,
    })

    React.useEffect(() => {
        const conn = new WebSocket(
            process.env.NODE_ENV === 'development'
                ? `ws://localhost:10001?token=${auth.access_token}`
                : `wss://iot-ws.jwelighting.com?token=${auth.access_token}`
        )

        setState((prev) => ({ ...prev, loading: true }))
        Axios.get('/batch')
            .then((res) => {
                const data = res.data
                const ref = state.ref
                const d = data.batch.map((row: any, index: number) => {
                    row._key = `Batch-${index + 1}`
                    row.nextRunTime = moment(row.lastRunTime).add({ minutes: row.mins })
                    ref[row._id] = React.createRef()
                    return row
                })
                setState((prev) => ({
                    ...prev,
                    data: d,
                    activeKey: `Batch-1`,
                    index: data.batch.length + 1,
                    his: data.his,
                    note: data.note ? data.note.note || '' : '',
                    ref,
                }))
            })
            .catch((err) => console.error(err))
            .finally(() => {
                setState((prev) => ({ ...prev, loading: false }))
            })
        conn.onmessage = handleReceiveMessage

        return () => {
            conn.close()
        }
    }, [])

    const onChange = (activeKey: string) => {
        setState((prev) => ({
            ...prev,
            activeKey,
        }))
    }

    const handleReceiveMessage = (messageObject: any) => {
        const message = messageObject.data
        const data = JSON.parse(message)
        console.log(data)
        if (data.action === 'update_sub_process') {
            const his = state.realTimeHistory
            his.push(data)
            setState((prev) => ({ ...prev, realTimeHistory: his }))
        } else if (data.status === 'processing') {
            const ref = state.ref[data._id]
            if (ref.current) ref.current.setIndex(data.nowIndex)
        } else if (data.status === 'done') {
            setState((prev) => ({
                ...prev,
                data: prev.data.filter((el) => el._id !== data._id),
                his: prev.his.map((row) => (row._id === data._id ? data : row)),
            }))
        } else {
        }
    }

    const onEdit = (targetKey: React.MouseEvent | React.KeyboardEvent | string, action: 'add' | 'remove') => {
        if (action === 'add') add()
        else if (action === 'remove') remove(targetKey as string)
    }

    const add = () => {
        setState({
            ...state,
            data: [
                ...state.data,
                {
                    _key: `Batch-${state.index}`,
                    district: [],
                    platform: '',
                    contains: '',
                    command: '',
                    mins: '',
                    times: '',
                    devices: [],
                    retry: '',
                    timeNeed: '',
                },
            ],
            index: state.index + 1,
        })
    }

    const remove = (targetKey: string | React.MouseEvent<HTMLElement>) => {
        let { activeKey } = state
        let lastIndex = -1
        state.data.forEach((pane, i) => {
            if (pane._key === targetKey) {
                lastIndex = i - 1
            }
        })

        const panes = state.data.filter((pane) => pane._key !== targetKey)
        if (panes.length && activeKey === targetKey) {
            if (lastIndex >= 0) {
                activeKey = panes[lastIndex]._key
            } else {
                activeKey = panes[0].key
            }
        }
        setState({
            ...state,
            data: panes,
            activeKey,
        })
    }

    const update = (index: number, value: any) => {
        const his = state.his
        if (his.length >= 5) his.pop()
        his.unshift(value)

        const d = state.data
        d[index] = value
        const ref = state.ref
        ref[value._id] = React.createRef()
        setState((prev) => ({
            ...prev,
            data: d,
            his,
            ref,
        }))
    }

    const deleteBatch = async (key: string) => {
        const batch = state.data.find((e) => e._id === key)

        if (batch) {
            Axios.put(`/batch/${key}`).then((res) => {
                if (res.status === 200) {
                    batch.status = 'stop'
                    setState((prev) => ({
                        ...prev,
                        data: prev.data.filter((el) => el._id !== key),
                        his: prev.his.map((a) => (a._id === key ? batch : a)),
                    }))
                }
            })
        }
    }

    return (
        <Spin spinning={state.loading}>
            <Row>
                <Col span={16}>
                    <div className="card-container">
                        <Tabs
                            type="editable-card"
                            tabPosition="top"
                            onEdit={onEdit}
                            activeKey={state.activeKey}
                            onChange={onChange}
                        >
                            {state.data.map((row, index) => (
                                <TabPane tab={row._key} key={row._key}>
                                    <Batch
                                        remove={deleteBatch}
                                        update={update}
                                        index={index}
                                        {...row}
                                        ref={state.ref[row._id]}
                                    />
                                </TabPane>
                            ))}
                        </Tabs>
                    </div>
                </Col>
                <Col span={8}>
                    <TextArea
                        rows={10}
                        value={state.note}
                        onPressEnter={(e) => {
                            Axios.post(`/note/`, {
                                note: state.note,
                            })
                        }}
                        onChange={(e) => {
                            e.persist()
                            setState((prev) => ({
                                ...prev,
                                note: e.target.value,
                            }))
                        }}
                    />
                    <div
                        style={{
                            maxHeight: '235px',
                            height: '235px',
                            border: '1px solid #d9d9d9',
                            marginTop: '5px',
                            overflowY: 'auto',
                            backgroundColor: '#fff',
                            borderRadius: '4px',
                        }}
                    >
                        {state.realTimeHistory.map((item, index) => (
                            <div style={{ padding: '10px' }} key={`info-${index}`}>
                                {item.device.title} - {item.status} - {item.error || ''}
                            </div>
                        ))}
                    </div>
                    {/* <List
                    bordered
                    dataSource={state.realTimeHistory}
                    renderItem={(item: any) => (
                        <List.Item>
                            <Typography.Text mark>{item.date}</Typography.Text>
                            {item.device.title} - {item.status}
                        </List.Item>
                    )}
                    style={{ marginTop: '20px' }}
                /> */}
                    <Timeline style={{ marginTop: '40px' }}>
                        {state.his.map((row, index) => {
                            let color = ''
                            if (row.status === 'stop') color = 'red'
                            else if (row.status === 'processing') color = 'blue'
                            else if (row.status === 'done') color = 'green'

                            return (
                                <Timeline.Item color={color} key={`timeline-${index}`}>
                                    {moment(row.date).format('YYYY-MM-DD HH:mm:ss')} - {row.command} - {row.status}
                                    <div>
                                        District: {row.district === '' ? 'N/A' : row.district}; Platform:{' '}
                                        {row.platform === '' ? 'N/A' : row.platform}, Sensor ID Contains:{' '}
                                        {row.contains === '' ? 'N/A' : row.contains}
                                    </div>
                                    <div>
                                        Retry: {row.mins} mins, {row.times} times
                                    </div>
                                </Timeline.Item>
                            )
                        })}
                    </Timeline>
                </Col>
            </Row>
        </Spin>
    )
}

export default BatchRegister
